// extracted by mini-css-extract-plugin
export var clickableWrapper = "_31-2";
export var placeholderIcon = "_31-3";
export var thumbnailCanvas = "_31-1";
export var thumbnailWrapper = "_31-0";